const mmpPrevSessionStartTimeKey: string = '__mmp_metrics_session_start_time__';
const mmpPrevUserIdKey: string = '__mmp_metrics_user_id__';
const mmpPrevStreamIdKey: string = '__mmp_metrics_stream_id__';
const mmpPrevPageUrlKey: string = '__mmp_metrics_page_url__';

const prevStreamId: string = sessionStorage.getItem(mmpPrevStreamIdKey) || '';
const prevSessionStartTime: number = Number(
  sessionStorage.getItem(mmpPrevSessionStartTimeKey) || '0',
);

const userIdFromSessionStorage: string | null = sessionStorage.getItem(mmpPrevUserIdKey);
const prevUserId: string | number =
  Number(userIdFromSessionStorage).toString() === userIdFromSessionStorage
    ? Number(userIdFromSessionStorage)
    : userIdFromSessionStorage || '';

const prevPageUrl: string | null = sessionStorage.getItem(mmpPrevPageUrlKey);

export const setPageUrl: (pageUrl: string) => void = (pageUrl) => {
  sessionStorage.setItem(mmpPrevPageUrlKey, pageUrl);
};

export const setStreamId: (streamId: string) => void = (streamId: string) => {
  sessionStorage.setItem(mmpPrevStreamIdKey, streamId);
  setPageUrl(window.location.toString());
};

export const setUserId: (userId: string | number) => void = (sessionId: string | number) => {
  sessionStorage.setItem(mmpPrevUserIdKey, sessionId.toString());
};

export const setSessionStartTime: (sessionStartTime: number) => void = (
  sessionStartTime: number,
) => {
  sessionStorage.setItem(mmpPrevSessionStartTimeKey, sessionStartTime.toString());
};

export const checkIfPageWasReloaded: () => boolean = () => {
  return (
    !!prevStreamId &&
    !!prevSessionStartTime &&
    !!prevUserId &&
    window?.location.toString() === prevPageUrl
  );
};

export const getPrevSessionStartTime: () => number = () => {
  return prevSessionStartTime;
};

export const getPrevUserId: () => number | string = () => {
  return prevUserId;
};

export const getPrevStreamId: () => number | string = () => {
  return prevStreamId;
};
